<template>
    <div
        class="dropdown border-default bg-primary-white domain-dropdown tab-dropdown"
        :class="{
            'border-disabled': !isResults
        }"
        id="dropdown-container"
    >
        <button
            type="button"
            id="domain-button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="align-items-center w-100 border-0 d-flex h-100 outline-none text-nowrap bg-primary-white line-height-0 position-absolute top-0 left-0 bg-none"
            :class="{
                'dropdown-toggle': !selected
            }"
            @click="$emit('open', $event)"
            ref="dropdown"
        >
            <span class="mt-1">
                <GeoIcon></GeoIcon>
            </span>

            <div
                class="mt-1 subcaption text-primary-black content text-elipsis"
                :class="{ 'text-disabled': !isResults, 'subcaption-strong': selected }"
            >
                {{ selected ? selected.data.label : store.contents.placeHolders.domains }}
            </div>
            <span class="mt-1 justify-content-end flex-grow-1 arrow-up">
                <ArrowUp :isDisabled="!isResults"></ArrowUp>
            </span>
            <span class="mt-1 justify-content-end flex-grow-1 arrow-down">
                <ArrowDown></ArrowDown>
            </span>

            <!-- <i
				class="fas fa-times d-none d-lg-inline ml-2"
				v-if="selected"
				@click="clear"
			></i>
			<i
				class="fas fa-times-circle d-inline d-lg-none ml-2"
				v-if="selected"
				@click="clear"
			></i> -->
        </button>
        <ul
            class="dropdown-menu domains-dropdown shadow-4 tf-scroll-container--50vh w-100"
            @click.stop
            :class="{
                'd-none': !isResults
            }"
        >
            <template v-for="item in domains">
                <li
                    class="py-1 px-4 subcaption text-primary-black cursor-pointer"
                    :class="{
                        'bg-primary-blue text-primary-white': item.isSelected
                    }"
                    @click="toggle(item)"
                    :key="item.type + item.data.label"
                >
                    {{ item.data.label }}
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import GeoIcon from '@se/components/svg/common/geo/index.vue'
import ArrowUp from '@se/components/svg/common/arrow-up/index.vue'
import ArrowDown from '@se/components/svg/common/arrow-down/index.vue'
import { onClickOutside } from '@vueuse/core'

export default {
    name: 'Domains',
    components: {
        ArrowUp,
        ArrowDown,
        GeoIcon
    },
    props: {
        store: Object
    },
    data() {
        return {
            off: []
        }
    },
    computed: {
        domains() {
            return this.store.data.geoData.domains
                .reduce((list, domain) => {
                    return this.store.data.available.domainsMap[domain.id]
                        ? [
                              ...list,
                              {
                                  type: 'domaineSki',
                                  data: domain,
                                  isSelected: this.store.data.selected.domain === domain.id
                              }
                          ]
                        : [...list]
                }, [])
                .sort((a, b) => (a.data.label > b.data.label ? 1 : -1))
        },
        selected() {
            if (this.store.data.selected.domain) {
                const domainId = this.store.data.selected.domain
                const domain = this.store.data.geoData.domainsMap[domainId]
                if (!domain) {
                    return null
                }
                return {
                    type: 'domaineSki',
                    data: domain
                }
            }
            return null
        },
        isResults() {
            return !!this.domains.length
        }
    },
    methods: {
        toggle(item) {
            if (item.isSelected) {
                this.unselect(item)
            } else {
                this.select(item)
            }
        },
        select(item) {
            if (item.type === 'domaineSki') {
                this.store.libs.se.batch(() => {
                    this.store.libs.se.setFieldValue('domaineSki', item.data.id)
                    this.store.libs.se.setFieldValue('parentStation', undefined)
                    this.store.libs.se.setFieldValue('station', undefined)
                })
            }
            $(this.$refs.dropdown).dropdown('hide')
            // this.$emit('select');
        },
        unselect(item) {
            this.store.libs.se.batch(() => {
                this.store.libs.se.setFieldValue('domaineSki', undefined)
            })
        },
        clear() {
            this.unselect(this.selected)
            $(this.$refs.dropdown).dropdown('hide')
        },
        showDropdown() {
            $(this.$refs.dropdown).dropdown('show')
        }
    },
    beforeDestroy() {
        this.off.forEach((off) => off())
    },
    mounted() {
        const se = this.store.libs.se
        this.off.push(
            se.onAvailableFieldValues(
                'domaineSki',
                () => {
                    const domains = se.getAvailableFieldValues('domaineSki')
                    this.store.data.available.domains = domains
                    this.store.data.available.domainsMap = domains.reduce((map, value) => ((map[value] = true), map), {})
                },
                true
            )
        )

        this.off.push(
            se.onFieldValue(
                'domaineSki',
                () => {
                    const domain = se.getFieldValue('domaineSki') || null
                    this.store.data.selected.domain = domain
                },
                true
            )
        )

        onClickOutside(this.$refs.dropdown, () => {
            $(this.$refs.dropdown).dropdown('hide')
        })
    }
}
</script>

<style scoped>
.arrow-up {
    display: flex;
}

.arrow-down {
    display: none;
}

.domain-dropdown.show .arrow-down {
    display: flex;
}

.domain-dropdown.show .arrow-up {
    display: none;
}
</style>
